import { Component, OnInit, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoService, IFechaVencimientoQueryParams } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { GuiaDespachoCabeceraComponent } from './guia-despacho-cabecera/guia-despacho-cabecera.component';
import { GuiaDespachoDetallesComponent } from './guia-despacho-detalles/guia-despacho-detalles.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { DataCafService } from 'src/app/services/data-caf.service';

@Component({
  selector: 'app-guia-despacho',
  templateUrl: './guia-despacho.component.html',
  styleUrls: ['./guia-despacho.component.scss'],
  providers: [SecurityService],
})
export class GuiaDespachoComponent implements OnInit {
  @ViewChild(GuiaDespachoCabeceraComponent, { static: true }) cabeceraComponent: GuiaDespachoCabeceraComponent;
  @ViewChild(GuiaDespachoDetallesComponent, { static: true }) detallesComponent: GuiaDespachoDetallesComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  processing: boolean = false;

  public permiteUnidadNegocio: boolean = false;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  // Utils
  private log: any;
  codigos_dte: number[];

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private documentoService: DocumentoService,
    private unidadNegocioService: UnidadNegocioService,
    private rutService: RutService,
    private parametroEmpresaService: ParametroEmpresaService,
    private dataCafService: DataCafService
  ) {
    this.log = this.clog.log('MAIN');

    // Seteamos los codigos DTE
    this.codigos_dte = [52];
    // Seteamos el valor del codigo DTE
    this.dataCafService.setDataCodigoDTE(52);
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.parametroUnidadNegocio();
    this.loadUnidadNegocio();
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }

  handleClienteChange(cliente) {
    this.detallesComponent.handleClienteChange(cliente);
  }

  handleSucursalChange(sucursal) {
    this.detallesComponent.handleSucursalChange(sucursal);
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
    });
  }

  onProductAdded(tipo: 'LIBRE' | 'NORMAL') {
    this.cabeceraComponent.disableHeader(tipo);
  }

  guardar() {
    const headerData = this.cabeceraComponent.getHeaderData();
    const detailsData = this.detallesComponent.getDetailsData();

    this.log('headerData', headerData);
    this.log('detailsData', detailsData);

    const { cliente, form, sucursal, condicionPago } = headerData;
    const { detalleDocumento } = detailsData;

    let breakProcess: boolean = false;

    if (!detalleDocumento || detalleDocumento.length === 0) {
      this.toastrService.warning('Ingrese producto(s)');
      breakProcess = true;
    }

    const isValidHeaderData = this.cabeceraComponent.validateForm();
    if (!isValidHeaderData) {
      this.toastrService.warning('Complete datos requeridos');
      breakProcess = true;
    }

    if (breakProcess) return;

    const inputParamsFechaVencimiento: IFechaVencimientoQueryParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: cliente.rut,
      direccion_codigo: sucursal.codigo,
      fecha_documento: form.fechaEmision,
      condicion_pago_codigo: condicionPago,
    };
    this.documentoService.ObtenerFechaVencimiento(inputParamsFechaVencimiento, ({ mensajes, respuesta }) => {
      this.guardarGuiaDespacho(headerData, detailsData, respuesta.fecha_vencimiento);
    });
  }

  private guardarGuiaDespacho(headerData, detailsData, fecha_vencimiento) {
    console.log('muestrame DATA CABECERA ', headerData);
    const { cliente, form, sucursal, vendedor, codigo_bodega_entrada, codigo_bodega_salida, observaciones } = headerData;
    const { detalleDocumento, totales } = detailsData;
    const inputParams = {
      entidad: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          tipo_dte_codigo: 52, // FIJO
          unidad_negocio_codigo: headerData.unidad_negocio_codigo,
          codigo_bodega_origen: codigo_bodega_salida,
          codigo_bodega_destino: codigo_bodega_entrada,
          tipo_traslado_codigo: Number(form.tipoTraslado),
          tipo_envio_codigo: Number(form.tipoEnvio),
          cliente_proveedor_rut: cliente.rut,
          condicion_pago_codigo: Number(form.condicionPago),
          sucursal_codigo: this.sucursalEmpresa,
          vendedor_codigo: vendedor.codigo,
          fecha_emision: form.fechaEmision,
          rut_receptor: cliente.rut,
          direccion_completa_facturacion: sucursal.direccion_completa,
          comuna_facturacion: sucursal.nombreComuna,
          provincia_facturacion: sucursal.nombreProvincia,
          region_facturacion: sucursal.nombreRegion,
          direccion_completa_despacho: sucursal.direccion_completa,
          comuna_despacho: sucursal.nombreComuna,
          princia_despacho: sucursal.nombreProvincia,
          region_despacho: sucursal.nombreRegion,
          giro_cliente: cliente.giro,
          fono_cliente: cliente.telefono_principal,
          monto_descuento: totales.descuento,
          monto_recargo: totales.recargo,
          subtotal_neto: totales.subtotal,
          monto_total_neto: totales.neto,
          monto_iva: totales.iva,
          monto_afecto: totales.afecto,
          monto_exento: totales.exento,
          subtotal: totales.subtotal,
          monto_total: totales.total,
          nota_venta: '', // FIJO
          orden_compra: '', // FIJO
          // fecha_registro: "2021-01-01", // ?
          aplica_rebaja: form.rebajaStock,
          aplica_recorrido: false, // FIJO
          observaciones,
          ticket_sii: 0, // FIJO
          fecha_vencimiento: fecha_vencimiento, // "2021-01-04",
          // dia_emision: 31, // ?
          // mes_emision: 12, // ?
          id_lsoft: 0, // FIJO
          motivo_devolucion_codigo: 0, // FIJO
          tipo_despacho_codigo: 0, // FIJO
          centro_costo_codigo: '', // FIJO
          forma_pago_codigo: 0, // FIJO
          tipo_destinatario_codigo: 0, // FIJO
          es_entrega_gratuita: false, // FIJO
          direccion_codigo: sucursal.codigo,
          usuario_rut_usuario: this.rutUsuario,
          tipo_ncnd_codigo: 0, // FIJO
          glosa_administrativa: '', // FIJO
        },
        descuentosGlobales: [],
        detalleDocumento,
      },
    };

    this.log(inputParams);
    this.log(JSON.stringify(inputParams));
    // return
    this.processing = true;

    this.guardarGuiaDespachoMutation(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        return;
      }

      const folio = respuesta.cabecera.folio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      this.toastrService.success(`Guía de Despacho nro: ${folio} creada.`);
      this.processing = false;
      this.clearForms();

      this.contadorFacturas++;
    });
  }

  private guardarGuiaDespachoMutation(inputParams, callback) {
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: documentoDTOInputType) {
            documento {
              guardarGuiaDespacho(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento.guardarGuiaDespacho;
        callback({ respuesta, mensajes });
      }
    );
  }

  private clearForms() {
    this.cabeceraComponent.clearForm();
    this.detallesComponent.clearForm();
  }

  clearFromButton() {
    this.modalConfirm.show(() => {
      this.clearForms();
    });
  }
}
